import DatePicker from 'vue2-datepicker';
import sr from 'date-format-parse/lib/locale/sr';

var lang = {
  formatLocale: sr,
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: true
};
DatePicker.locale('sr', lang);

export default lang;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue2-datepicker/locale/es/sr.js
// module id = 339
// module chunks = 0